module.exports = {
    "bulk": [
        "",
        "Cement Carrier",
        "Wood Chips Carrier",
        "Aggregate Carrier",
        "Limestone Carrier",
        "Ore/Sulphuric Acid Carrier",
        "Ore Carrier",
        "Salt Carrier",
        "Slurry Carrier",
        "Urea Carrier",
        "Self Discharging Bulk Carrier",
        "Powder Carrier",
        "Bauxite Carrier",
        "Grain Carrier",
    ],
    "bulktank": [
        "",
        "Bulk/Oil Carrier",
        "Bulk/Liquid Carrier",
        "OBO Carrier (ore/bulk/oil)",
    ],
    "mpp": [
        "",
        "Container/Bulk Ship",
        "Container/Break Bulk Ship",
        "Deck Cargo Carrier",
        "Heavy Load Carrier",
        "Heavy Lift Vessel",
        "Landing Craft",
        "Palletised Cargo Carrier",
        "Ro-Ro/Pass Carrier",
        "Ro-Lo Cargo Carrier",
        "Ro-Ro Cargo Carrier",
        "Ro-Ro/Container carrier",
        "Timber Carrier",
        "Gen cargo - Hazard A (Major)",
        "Gen cargo - Hazard D (Recognizable)",
        "Gen cargo - Hazard B",
        "Gen cargo - Hazard C (Minor)",
    ],
    "livestock": [
        "",
        "Livestock Carrier",
        "Open Livestock Carriers",
        "Close Livestock Carriers",
    ],
    "reefer": [
        "",
        "Reefer/General Cargo",
        "Reefer Fish Carrier",
        "Reefer/Pallets Carrier",
        "Reefer/Ro-Ro Cargo",
        "Reefer/Containership",
    ],
    "tank": [
        "",
        "Chemical Tanker",
        "Chemical/Oil Products Tanker",
        "Oil Products Tanker",
        "Fruit Juice Carrier",
        "Methanol Carrier",
        "Molten Sulphur Carrier",
        "Oil/Liquid Gas Carrier",
        "Oil Recovery Tanker",
        "Phosphoric Acid Carrier",
        "Oil Products Tanker",
        "Shuttle Tanker",
        "Sulphuric Acid Carrier",
        "Waste Disposal Carrier",
        "Water Carrier",
        "Asphalt/Bitumen Carrier",
        "Bunkering Tanker",
        "LNG Tanker",
        "LPG Tanker",
        "Crude Oil Tanker",
        "CO2 Tanker",
        "Wine Tanker",
        "Tanker - Hazard A (Major)",
        "Tanker - Hazard B",
        "Tanker - Hazard C (Minor)",
        "Tanker - Hazard D (Recognizable)",
    ],
    "cont": [
        "",
        "Barge/Lichter Carrier",
        "Fully Cellular Container Ship",
    ],
    "car": [
        "",
        "Vehicles Carrier",
        "Rail/Vehicles Carrier",
    ],
    "passcar": [
        "",
        "Passenger/Ro-Ro Cargo Ship",
        "Passenger/Cargo Ship",
    ],
    "pass": [
        "",
        "Cruise/Passenger Ship",
    ],
};



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/specialtyConfig.js